import { getLocalApi } from "./localApi";
import { RoomType} from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllRoomTypes() : Promise<RoomType[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_room_types, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch room types')
}